module.exports = __webpack_public_path__ + "img/mind_template_item_1_6.2866672f.png";